import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import "../Sass/PrivacyPolicy.scss"

const PrivacyPolicy = () => {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        const href = window.location.href.substring(
            window.location.href.lastIndexOf('#') + 1
        );
        const element = document.getElementById(href);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const [display, setDisplay] = useState("none");

    const show = () => {
        setDisplay("block");
    }

    const hide = () => {
        setDisplay("none");
    }

    const up = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setDisplay("none");
    }
    const [animation, setAnimation] = useState("zoom-in-zoom-out 2s ease-out 1");

    const down = () => {
        window.scrollTo({ top: 10000, left: 0 });
        setDisplay("none");

        if (animation === "zoom-in-zoom-out 2s ease-out 1") {
            setAnimation("none");
        }
        else {
            setAnimation("zoom-in-zoom-out 2s ease-out 1");
        }
    }
    const hidden = () => {
        setDisplay("none");
    }

    return (
        <div>
            {/* Header */}
            <header>
                <div className="logo">
                    {/* <img rel='preload' fetchpriority="high" src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702125402/Akcit 500/logo_zjql0r.webp" alt="logo" /> */}
                    <h1>Akcit 500</h1>

                </div>
                <div className="links">
                    <Link to={"/"} onClick={up}>Home</Link>
                    <Link onClick={hidden} to={"/#about"}>About</Link>
                    <Link onClick={down} to={"#contact"} >Contact Us</Link>
                    <Link onClick={hidden} to={"/#buy-now"}>Buy Now</Link>
                </div>

                {/* <div id='navbar-mobile' style={{ display: display }}>
                    <svg className='cross' onClick={hide} id="Capa_1" enable-background="new 0 0 320.591 320.591" height="512" viewBox="0 0 320.591 320.591" width="512" xmlns="http://www.w3.org/2000/svg"><g><g id="close_1_"><path d="m30.391 318.583c-7.86.457-15.59-2.156-21.56-7.288-11.774-11.844-11.774-30.973 0-42.817l257.812-257.813c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875l-259.331 259.331c-5.893 5.058-13.499 7.666-21.256 7.288z" /><path d="m287.9 318.583c-7.966-.034-15.601-3.196-21.257-8.806l-257.813-257.814c-10.908-12.738-9.425-31.908 3.313-42.817 11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414-6.35 5.522-14.707 8.161-23.078 7.288z" /></g></g></svg>

                    <div className="links">
                        <Link to={"/"} onClick={up}>Home</Link>
                        <a onClick={hidden} href="#about">About Akcit 500</a>
                        <a onClick={down} href="#contact">Contact</a>
                        <a onClick={hidden} href="#buy">Buy Now</a>

                    </div>
                </div>
                <svg className='menu' onClick={show} id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m512 256.002c0 17.673-14.327 32-32 32h-307.059c-17.673 0-32-14.327-32-32s14.327-32 32-32h307.059c17.673 0 32 14.327 32 32zm-339.059-134.55h307.059c17.673 0 32-14.327 32-32s-14.327-32-32-32h-307.059c-17.673 0-32 14.327-32 32s14.328 32 32 32zm307.059 269.096h-307.059c-17.673 0-32 14.327-32 32s14.327 32 32 32h307.059c17.673 0 32-14.327 32-32s-14.327-32-32-32zm-419.195-333.096h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32zm0 166.551h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32zm0 166.542h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32z" /></svg> */}

            </header>
            {/* Header Ends */}

            {/* Privacy Policy */}
            <div className="privacy-policy">
                <div className="title">
                    <h4>Privacy Policy</h4>
                    <p></p>
                </div>

                <p>Welcome to Akcit 500, a product of Akcent Health Care. We are committed to protecting your
                    privacy and ensuring a safe experience. This Privacy Policy outlines how we collect, use, and
                    safeguard your personal information when you visit our website and interact with our products and
                    services.</p>
                {/* <p>Welcome to Akcent Healthcare Pvt Ltd ("us", "we", or "our"). Your privacy is important to us. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website.</p> */}


                <h3>Information We Collect</h3>
                <p>We collect the following types of information:</p>
                <ol>
                    <li>Personal Information: <br />
                        <ul>
                            <li>Name</li>
                            <li>Email address</li>
                            <li>Phone number</li>
                            <li>Any other information you provide when you contact us or make a purchase</li>
                        </ul>
                    </li>

                    <li>Usage Data:<br />
                        <ul>
                            <li>Information about your visit to our website, including IP address, browser type, and
                                usage patterns.</li>
                        </ul>
                    </li>

                    <li>Cookies and Tracking:

                        <ul>
                            <li>We may use cookies, which are similar to tracking technologies, to enhance your
                                experience on our site.</li>
                        </ul>
                    </li>
                </ol>

                <h3>How We Use the Information</h3>
                <p>We may use the information we collect from you in the following ways</p>
                <ol>
                    <li>To Provide Services:

                        <ul>
                            <li>Process transactions</li>
                            <li>Deliver products</li>
                            <li>Provide customer support</li>
                        </ul>
                    </li>

                    <li>To Communicate With You:

                        <ul>
                            <li>Send you updates</li>
                            <li>Respond to your inquiries</li>
                        </ul>
                    </li>

                    <li>To Ensure Security:
                        <ul>
                            <li>Monitor and prevent fraudulent activities and unauthorized access to our systems.</li>
                        </ul>
                    </li>
                </ol>

                <h3>Data Security</h3>
                <p>We use appropriate technical and organizational measures to protect your personal data from
                    unauthorized access, disclosure, alteration, or destruction.</p>

                <h3>Your Rights</h3>
                <p>You have the following rights:</p>

                <ol>
                    <li>Access:
                        <ul>
                            <li>The right to request access to the personal data we hold about you.
                            </li>
                        </ul>
                    </li>

                    <li>Correction:
                        <ul>
                            <li>The right to request corrections of any inaccurate or incomplete data.</li>
                        </ul>
                    </li>
                </ol>

                <h3>Changes To This Policy</h3>
                <p>We may update this Privacy Policy from time to time. When we make changes, we encourage you to
                    review the policy periodically to stay informed about how we are protecting your information.</p>

                <h3>Contact Us</h3>
                <p>If you have any questions or concerns about this Privacy Policy or our data practices, please
                    contact us at:</p>

                <h3>Akcent Health Care</h3>
                <ul>
                    <li>[Address -7/27 ,Block 8 Kirti Nagar Industrial Area ]</li>
                    <li> [City, State, Zip] [Delhi ,Delhi ,110015]</li>
                    <li> [Phone Number] [01145009554]</li>
                </ul>

            </div>
            {/* Privacy Policy Ends*/}

            {/* Footer */}
            <footer id='contact'>
                <div className="footer-top">
                    <div className="footer-subscribe">
                        <h3>Empowering neuromuscular health enhancing cognitive vitality</h3>
                        {/* <p>Subscribe and rediscover radiance, confidence and unseen insights </p> */}

                        <div className="subscribe">
                            <input type="text" placeholder='Enter Your Email' />
                            <button>Subscribe</button>
                        </div>

                        <div class="footer-follow">
                            <a target="_blank" rel="noreferrer" href="https://www.facebook.com/akcenthealthcaresales/">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
                            </a>

                            {/* <a target="_blank" rel="noreferrer" href="https://twitter.com/AkcentHealthca1">

                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>

                            </a> */}


                            <a target="_blank" href="https://www.instagram.com/AkcentHealthCare">
                                <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m6.5 1c-3.03757 0-5.5 2.46243-5.5 5.5v11c0 3.0376 2.46243 5.5 5.5 5.5h11c3.0376 0 5.5-2.4624 5.5-5.5v-11c0-3.03757-2.4624-5.5-5.5-5.5zm5.5 7c-2.20914 0-4 1.79086-4 4 0 2.2091 1.79086 4 4 4 2.2091 0 4-1.7909 4-4 0-2.20914-1.7909-4-4-4zm-6 4c0-3.31371 2.68629-6 6-6 3.3137 0 6 2.68629 6 6 0 3.3137-2.6863 6-6 6-3.31371 0-6-2.6863-6-6zm12-8c-1.1046 0-2 .89543-2 2s.8954 2 2 2 2-.89543 2-2-.8954-2-2-2z" fill="#000" fill-rule="evenodd" /></svg>
                            </a>
                            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/akcent-healthcare-india-pvt-ltd/about/">

                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>

                            </a>

                            <a target="_blank" href="https://wa.me/919315914499">
                                <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m435.921875 74.351562c-48.097656-47.917968-112.082031-74.3242182-180.179687-74.351562-67.945313 0-132.03125 26.382812-180.445313 74.289062-48.5 47.988282-75.234375 111.761719-75.296875 179.339844v.078125.046875c.0078125 40.902344 10.753906 82.164063 31.152344 119.828125l-30.453125 138.417969 140.011719-31.847656c35.460937 17.871094 75.027343 27.292968 114.933593 27.308594h.101563c67.933594 0 132.019531-26.386719 180.441406-74.296876 48.542969-48.027343 75.289062-111.71875 75.320312-179.339843.019532-67.144531-26.820312-130.882813-75.585937-179.472657zm-180.179687 393.148438h-.089844c-35.832032-.015625-71.335938-9.011719-102.667969-26.023438l-6.621094-3.59375-93.101562 21.175782 20.222656-91.90625-3.898437-6.722656c-19.382813-33.425782-29.625-70.324219-29.625-106.71875.074218-117.800782 96.863281-213.75 215.773437-213.75 57.445313.023437 111.421875 22.292968 151.984375 62.699218 41.175781 41.03125 63.84375 94.710938 63.824219 151.152344-.046875 117.828125-96.855469 213.6875-215.800781 213.6875zm0 0" /><path d="m186.152344 141.863281h-11.210938c-3.902344 0-10.238281 1.460938-15.597656 7.292969-5.363281 5.835938-20.476562 19.941406-20.476562 48.628906s20.964843 56.40625 23.886718 60.300782c2.925782 3.890624 40.46875 64.640624 99.929688 88.011718 49.417968 19.421875 59.476562 15.558594 70.199218 14.585938 10.726563-.96875 34.613282-14.101563 39.488282-27.714844s4.875-25.285156 3.414062-27.722656c-1.464844-2.429688-5.367187-3.886719-11.214844-6.800782-5.851562-2.917968-34.523437-17.261718-39.886718-19.210937-5.363282-1.941406-9.261719-2.914063-13.164063 2.925781-3.902343 5.828125-15.390625 19.3125-18.804687 23.203125-3.410156 3.894531-6.824219 4.382813-12.675782 1.464844-5.851562-2.925781-24.5-9.191406-46.847656-29.050781-17.394531-15.457032-29.464844-35.167969-32.878906-41.003906-3.410156-5.832032-.363281-8.988282 2.570312-11.898438 2.628907-2.609375 6.179688-6.179688 9.105469-9.582031 2.921875-3.40625 3.753907-5.835938 5.707031-9.726563 1.949219-3.890625.972657-7.296875-.488281-10.210937-1.464843-2.917969-12.691406-31.75-17.894531-43.28125h.003906c-4.382812-9.710938-8.996094-10.039063-13.164062-10.210938zm0 0" /></svg>
                            </a>
                        </div>
                    </div>

                    {/* <div className="footer-about">
                            <h4>Links</h4>
                            <ul>
                                <li>
                                    <Link to={"/"} onClick={up}>Home</Link></li>
                                <li><Links
                                    activeClass="active"
                                    to="about"
                                    spy={true}
                                    smooth={true}
                                    offset={-40}
                                    duration={100}
                                >
                                    About
                                </Links></li>
                                <li><Links
                                    activeClass="active"
                                    to="contact"
                                    spy={true}
                                    smooth={true}
                                    offset={-30}
                                    duration={100}
                                >
                                    Contact Us
                                </Links></li>
                                <li><Links
                                    activeClass="active"
                                    to="buy"
                                    spy={true}
                                    smooth={true}
                                    offset={-30}
                                    duration={100}
                                >
                                    Buy Now
                                </Links></li>

                            </ul>
                        </div> */}

                    <div className="footer-contact">
                        <h4>Contact</h4>
                        <ul>
                            <li>
                                <div className="svg">
                                    <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Call"><path d="m52.5 42.85-2.83-2.82a5.9873 5.9873 0 0 0 -8.48 0l-1.27 1.26a1.9573 1.9573 0 0 1 -1.83.54c-2.1-.47-5.49-1.92-9.74-6.17-4.26-4.26-5.71-7.65-6.18-9.75a1.9573 1.9573 0 0 1 .54-1.83l1.27-1.27a6.01768 6.01768 0 0 0 0-8.48l-2.83-2.83a6.01143 6.01143 0 0 0 -8.48 0l-.87.87a10.64659 10.64659 0 0 0 -2.89 9.89c1.49 6.71 6.41 15.28 11.98 20.85 5.57 5.56 14.14 10.49 20.84 11.98a10.96437 10.96437 0 0 0 2.34.26 10.68538 10.68538 0 0 0 7.56-3.15l.87-.87a6.01143 6.01143 0 0 0 0-8.48z"></path></g></svg>
                                </div>

                                <a href="tel:+911145009554">+91-1145009554</a>

                            </li>
                            <li>
                                <div className="svg">
                                    <svg viewBox="0 -77 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m490.753906 0h-469.507812l234.753906 234.453125zm0 0"></path><path d="m0 21.179688v316.445312l158.425781-158.222656zm0 0"></path><path d="m256 276.851562-76.347656-76.25-158.40625 158.203126h469.507812l-158.40625-158.203126zm0 0"></path><path d="m353.574219 179.402344 158.425781 158.222656v-316.445312zm0 0"></path></svg>
                                </div>

                                <a href="mailto:akcenthealthcare@gmail.com">akcenthealthcare@gmail.com</a>
                            </li>
                            <li>
                                <div className="svg">
                                    <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-105.6 0-191.5 85.9-191.5 191.5 0 34.4 16.2 77.8 49.4 132.7 27.6 45.6 61.8 90.9 91.9 130.8 13.9 18.4 27 35.8 37.1 50.2 3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8c10.1-14.4 23.2-31.8 37.1-50.2 30.1-39.9 64.2-85.2 91.9-130.8 33.2-54.9 49.4-98.3 49.4-132.7 0-105.6-85.9-191.5-191.5-191.5zm0 280c-48.8 0-88.5-39.7-88.5-88.5s39.7-88.5 88.5-88.5 88.5 39.7 88.5 88.5-39.7 88.5-88.5 88.5z"></path></svg>
                                </div>

                                7/27, Block 8, Kirti Nagar Industrial Area Delhi-110015
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-copyright">
                    <p>&copy; 2024 Akcent Healthcare. All rights reserved.</p>

                    <div className="copy">
                        <Link to={"/privacy-policy"}>Privacy Policy</Link>
                    </div>
                </div>
            </footer>

            {/* Footer Ends */}
        </div>
    )
}

export default PrivacyPolicy
